import React from "react";
import { Button } from "@material-tailwind/react";
import * as XLSX from "xlsx"; // Importando a biblioteca xlsx
import logo from "../../images/logo/logo.png"; // Logo, caso precise inserir no arquivo

interface PatientData {
  dt_evento: string;
  hr_inicio: string;
  nome_paciente: string;
  nome_terapeuta: string;
  situacao: string; // Nova coluna
  atividade: string; // Nova coluna
  [key: string]: any; // Para outros campos adicionais dinâmicos
}

interface RelAgendaTerapeutaProps {
  data: Array<PatientData>;
  fields: string[]; // Campos que serão exibidos no relatório
  loading: boolean;
}

const RelAgendaTerapeutaExcel: React.FC<RelAgendaTerapeutaProps> = ({
  data,
  fields,
  loading,
}) => {
  // Agrupando os dados por terapeuta
  const groupedData = data.reduce(
    (acc, item) => {
      const therapistName = item.nome_terapeuta || "Sem Terapeuta";
      const date = item.dt_evento || "Sem Data";
      const time = item.hr_inicio || "Sem Horário";
      const patientName = item.nome_paciente || "Sem Nome";

      if (!acc[therapistName]) acc[therapistName] = {};

      if (!acc[therapistName][date]) {
        acc[therapistName][date] = {
          times: [],
          patients: [],
          situacoes: [],
          atividades: [],
        };
      }

      acc[therapistName][date].times.push(time);
      acc[therapistName][date].patients.push(patientName);
      acc[therapistName][date].situacoes.push(item.situacao || "N/A");
      acc[therapistName][date].atividades.push(item.atividade || "N/A");

      return acc;
    },
    {} as {
      [therapistName: string]: {
        [date: string]: {
          times: string[];
          patients: string[];
          situacoes: string[];
          atividades: string[];
        };
      };
    }
  );

  // Função para gerar o Excel
  const generateExcel = () => {
    const dataToExport: any[] = [];

    // Adicionando título do relatório
    dataToExport.push(["Atendimentos Terapeutas"]);

    // Cabeçalho da tabela
    dataToExport.push(["Terapeuta", "Data", "Horário", "Paciente", "Situação", "Atividade"]);

    // Iterando sobre os dados agrupados por terapeuta para adicionar na tabela
    Object.entries(groupedData).forEach(([therapistName, dates]) => {
      Object.entries(dates).forEach(([date, { times, patients, situacoes, atividades }]) => {
        times.forEach((time, i) => {
          dataToExport.push([
            therapistName,
            date,
            time,
            patients[i] || "",
            situacoes[i] || "N/A",
            atividades[i] || "N/A",
          ]);
        });
      });
    });

    // Criação do arquivo Excel
    const ws = XLSX.utils.aoa_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Relatório");

    // Exportando o arquivo Excel
    XLSX.writeFile(wb, "Relatório_Terapeutas.xlsx");
  };

  return (
    <div className="mt-6 text-center">
      <button
        type="button"
        className="px-6 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-500 focus:ring-opacity-50"
        onClick={generateExcel}
        disabled={loading} // Desabilita o botão se loading for true
      >
        Gerar Excel
      </button>
    </div>
  );
};

export default RelAgendaTerapeutaExcel;
